
angular.module('ui2.0Directives')
    .directive('leftPaneDeligation', ['$rootScope', '$http', '$location','$q','$timeout', function ($rootScope, $http, $location,$q,$timeout) {
        return {
            restrict: "E",
            templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/leftPaneDeligation.html"),
            link: function ($scope, element, attrs){
                $scope.noData = false;
                $scope.init = function() {
                    if (attrs.listid) {
                        $http({
                            method: 'GET',
                            url: "/delegation/getDelegationRequest/" + attrs.listid + "?_t=" + new Date().getTime()
                        }).then(function successCallback(response) {
                            if(!_.get(response,'data.length')){
                                $scope.noData = true;
                            } else {
                                $scope.noData = false;
                            }
                            $scope.delegationObjs = response.data;
                            $scope.activeDeligationId = _.get($scope,'delegationObjs[0].id') || 0;
                            $timeout(function () {
                                var tableScope = $("#table_" + attrs.tableid).scope();
                                tableScope.$emit("refreshData", {'delegationReqId':$scope.activeDeligationId, 'loadListData':true});
                            }, 10)
                            //letter avatar
                            $scope.delegationObjs.forEach(function (obj) {
                                if(attrs.listid === "335"){
                                    obj.userInitials = globalFunc.getUserInitials(obj.fromUser.name);
                                }
                                else{
                                    obj.userInitials = globalFunc.getUserInitials(obj.toUser.name);
                                }
                            })
                        }, function errorCallback(response) {
                            response?.statusText;
                        });
                    }
                }
                $scope.init();


                //refreshing data of left panel
                $rootScope.$on('refreshLeftPanel',function (data) {
                    if(attrs.listid ==="336")
                        $scope.init();
                });
                //hover on each delegation
                $scope.showInfoBox = false;
                $scope.isHoverOnDeligation = function(e,bool){
                    if(bool){
                        $(e.currentTarget).find('.deligation_hoverIcons').css({"display":"block"});
                    }
                    else{
                        $(e.currentTarget).find('.deligation_hoverIcons').css({"display":"none"});
                        $('.arrow_box_info').css({"display":"none"});
                    }
                }
                //to open confirmAlertBox on click of Remove
                $scope.cancelRemoveDele = function(e,delObj){
                    const args = {
                        popupType: 'confirm',
                        str: intl_msg[23574],
                        heading: intl_msg[25772],
                        yesCbFn: function(){
                            var req = {
                                method: 'POST',
                                url: '/delegation/delete',
                                data: { 'id':  delObj.id }
                            }
                            $http(req).then(function(response){
                                //Refreshing left panel after deletion of deligation
                                $scope.init();
                            }, function errorCallback (response){
                                response?.statusText;
                            });
                        },
                        noCbFn: function(){
                            return false;
                        }
                    }
                    SirionUtils.openSirionDialogs(args);
                }
                //Additional info box
                $scope.toggleInfoBox = function(e,bool){
                    if(bool){
                        $(e.currentTarget).find('.arrow_box_info').css({"display":"block","top": 35});
                    }
                    else{
                        $('.arrow_box_info').css({"display":"none"});
                    }
                }
                //Function to toggle ShowMore functionality for additional fields
                $scope.showMoreEntities = false;
                $scope.showMoreContracts = false;
                $scope.showMoreRoleGroups = false;
                $scope.showMoreSuppliers = false;
                $scope.showMore = function(addField){
                    switch (addField){
                        case 'entity':
                            $scope.showMoreEntities = !$scope.showMoreEntities;
                            break;
                        case 'contract':
                            $scope.showMoreContracts = !$scope.showMoreContracts;
                            break;
                        case 'roleGroup':
                            $scope.showMoreRoleGroups = !$scope.showMoreRoleGroups;
                            break;
                        case 'supplier':
                            $scope.showMoreSuppliers = !$scope.showMoreSuppliers;
                            break;
                    }

                }
                //function to render table for selected delegation
                $scope.renderTable = function(e,del){
                    $scope.activeDeligationId = del.id;
                    var tableScope = $("#table_"+attrs.tableid).scope();
                    tableScope.$broadcast("removeTotalCountFromTable");
                    tableScope.$emit("refreshData",{'delegationReqId':del.id, 'loadListData':true});
                };
            }
        }

    }]);
